<template>
  <div>
    <!-- start: page -->
    <form
      class="ecommerce-form action-buttons-fixed"
      @submit.prevent="submitForm"
    >
      <div class="row">
        <div class="col">
          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-slider"></i>
                  <h2 class="card-big-info-title">Izdvojena sekcija</h2>
                  <p class="card-big-info-desc">Unesite detalje</p>
                </div>

                <div class="col-lg-3-5 col-xl-4-5">
                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{ 'has-danger': $v.title.$anyError }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Naziv
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Naziv"
                        v-model="title"
                      />
                      <form-error
                        :model="$v.title"
                        :dirty="$v.$dirty"
                        label="Naziv"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{ 'has-danger': $v.contentTitle.$anyError }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Naslov
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Naslov"
                        v-model="contentTitle"
                      />
                      <form-error
                        :model="$v.contentTitle"
                        :dirty="$v.$dirty"
                        label="Naslov"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Glavni opis
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <textarea
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Glavni opis"
                        v-model="mainDescription"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Sporedni opis
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <textarea
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Sporedni opis"
                        v-model="secondaryDescription"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Link
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Link"
                        v-model="contentUrl"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Dostupno na</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <select
                        class="form-control form-control-modern"
                        v-model="highlightedCategoryContentType"
                      >
                        <option
                          v-for="item in b2borb2cOptions"
                          :value="item.id"
                          :key="item.id"
                        >
                          {{ item.text }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Vidljivo na glavnoj stranici?
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div class="checkbox-custom checkbox-default">
                        <input
                          id="visible-on-main-page"
                          name="agreeterms"
                          type="checkbox"
                          v-model="visibleOnMainPage"
                        />
                        <label
                          class="control-label"
                          for="visible-on-main-page"
                        ></label>
                      </div>
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Poravnanje
                    </label>

                    <div class="col-lg-7 col-xl-6">
                      <treeselect
                        v-model="alignment"
                        :multiple="false"
                        :options="alignments"
                        placeholder="Izaberite poravnanje"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Slika slidera</label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="file"
                        class="form-control form-control-modern"
                        ref="photo"
                        accept="image/*"
                        @change="handlePhotoUpload"
                      />
                      <span class="form-text">
                        Učitajte sliku rezolucije 855px x 480px
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div class="row action-buttons">
        <div class="col-12 px-md-0 mt-3 mt-md-0 d-flex justify-content-end gap-3">
          <router-link
            class="cancel-button btn btn-light btn-px-4 py-3 border font-weight-semibold text-color-dark text-3"
            exact
            :to="{ name: 'FeaturedCategories' }"
          >
            {{ translations.cancel }}
          </router-link>
          <button
            type="submit"
            class="ubmit-button btn btn-primary btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
          >
            <i class="bx bx-save text-4 me-2"></i> {{ translations.save }}
          </button>
        </div>
      </div>
    </form>
    <!-- end: page -->
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

import { translations } from '@/mixins';
import api from '@/services/api';
import config from '@/config';
import validations from './validation-schema/add';
import FormError from '../../shared/form-errors/FormError.vue';

export default {
  name: 'AddHighlightedCategory',
  mixins: [translations],
  validations,
  components: { Treeselect, FormError },
  data() {
    return {
      highlightedCategoryContentType: 3,
      b2borb2cOptions: [
        {
          id: 1,
          text: 'B2B',
        },
        {
          id: 2,
          text: 'B2C',
        },
        {
          id: 3,
          text: 'Sve',
        },
      ],
      alignments: [
        {
          id: 'left',
          label: 'Lijevo',
        },
        {
          id: 'right',
          label: 'Desno',
        },
      ],
      contentTitle: '',
      title: '',
      mainDescription: '',
      secondaryDescription: '',
      alignment: 'right',
      visibleOnMainPage: false,
      contentUrl: '',
      imageUrl: '',
    };
  },
  computed: {
    baseUrl() {
      return config.baseUrl;
    },
  },
  methods: {
    submitForm() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        this.$toast.error(this?.translations?.forms?.notValid);
        this.$nextTick(() => {
          const elem = document.querySelector('.has-danger');
          if (elem) {
            elem.scrollIntoView(true);
          }
        });
        return;
      }

      const {
        contentTitle,
        title,
        mainDescription,
        secondaryDescription,
        alignment,
        contentUrl,
        visibleOnMainPage,
        highlightedCategoryContentType,
      } = this;

      const payload = {
        contentTitle,
        title,
        mainDescription,
        secondaryDescription,
        alignment,
        contentUrl,
        visibleOnMainPage,
        highlightedCategoryContentType,
      };

      if (this.$refs.photo.files[0]) {
        const file = this.$refs.photo.files[0];

        payload.image = {
          file: this.imageUrl.split(',')[1],
          fileName: file.name
        };
      }

      api.createHighlightedCategory(payload).then((response) => {
        this.$toast.info(response.data.info);
        this.$router.push({ name: 'FeaturedCategories' });
      });
    },
    handlePhotoUpload() {
      const file = this.$refs.photo.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = (e) => {
        this.imageUrl = e.target.result;
      };
    },
  },
};
</script>
